import { Grid } from "@material-ui/core";
import MeditocInfoField from "../../utils/MeditocInfoField";
import MeditocModal from "../../utils/MeditocModal";
import MeditocSubtitulo from "../../utils/MeditocSubtitulo";
import { useFolio } from "../../../context/FolioContext";

export default function DetalleFolio() {
    const { folioSeleccionado, modalOpenDetalleFolio, handleOpenDetalleFolio } = useFolio();

    return (
        <MeditocModal
            title={"Detalle de folio " + folioSeleccionado.sFolio}
            setopen={handleOpenDetalleFolio}
            open={modalOpenDetalleFolio}
            okmessage="Cerrar detalle"
            size="small"
            hidecancel
        >
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <MeditocSubtitulo title="DATOS DE FOLIO" />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="ID de folio:" value={folioSeleccionado.iIdFolio} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Folio:" value={folioSeleccionado.sFolio} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Origen:" value={folioSeleccionado.sOrigen} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Orden de compra:" value={folioSeleccionado.sOrdenConekta} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Fecha de registro:" value={folioSeleccionado.sFechaCreacion} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Fecha de vencimiento:" value={folioSeleccionado.sFechaVencimiento} />
                </Grid>
                <Grid item xs={12}>
                    <MeditocSubtitulo title="DATOS DEL PRODUCTO" />
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField label="Nombre de producto:" value={folioSeleccionado.sNombreProducto} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Tipo de producto:" value={folioSeleccionado.sTipoProducto} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Grupo de productos:" value={folioSeleccionado.sGrupoProducto} />
                </Grid>
                <Grid item xs={12}>
                    <MeditocSubtitulo title="DATOS DEL PACIENTE" />
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField label="Nombre:" value={folioSeleccionado.sNombrePaciente} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Teléfono:" value={folioSeleccionado.sTelefonoPaciente} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Correo:" value={folioSeleccionado.sCorreoPaciente} />
                </Grid>
                <Grid item xs={12}>
                    <MeditocSubtitulo title="DATOS DE EMPRESA O CLIENTE" />
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField label="Nombre de empresa:" value={folioSeleccionado.sNombreEmpresa} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Folio de empresa:" value={folioSeleccionado.sFolioEmpresa} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Correo de empresa:" value={folioSeleccionado.sCorreoEmpresa} />
                </Grid>
            </Grid>
        </MeditocModal>
    );
}
